import { Component , EventEmitter,Input,OnInit, Output, ViewChild } from '@angular/core';


@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.css', '../date-time-picker.component.css'],
})
export class TimerComponent implements OnInit{
  @Output() time= new EventEmitter();
  @Input() field!: any;
  min: number[] = [];
  hours = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11','12'];
  hourElement = document.getElementById('Hour') as HTMLInputElement;
  hour: string = (new Date().getHours()>12?new Date().getHours()%12:new Date().getHours()) + '';
  minute: string = new Date().getMinutes() + '';
  meridiem: string =(new Date().toLocaleTimeString('en-US').split(' ')[1]);
  // @ViewChild('TimerPart') timerpartRef!:ElementRef;
  // @ViewChild('Hour',{static:false}) hourRef!:ElementRef;
  // @ViewChild('mins',{static:false}) minRef!:ElementRef;
  // @ViewChild('zone', {static:false}) zoneRef!:ElementRef;
  constructor() {
    

  }
 
  ngOnInit() {
    for (let i = 0; i < 60; i++) {
      let a: any = i;
      if (+i < 10) a = '0' + i;
      this.min.push(a);
    }
       if(this.field.hourFormat==24) {
      this.hours=['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11','12','13','14','15','16','17','18','19','20','21','22','23','24'];
      this.hour=new Date().getHours()+''
    }
      this.valueFormating()   
  }
  valueFormating() {
    if (this.hour == '' || this.minute == '') {
      return 
    }
    else {
      if((+this.hour)<10) this.hour='0'+(+this.hour);
      if((+this.minute)<10) this.minute='0'+(+this.minute);
      if(this.field.hourFormat!=24){
        this.time.emit(this.hour + ' : ' + this.minute + ' ' + this.meridiem)
        return this.hour + ' : ' + this.minute + ' ' + this.meridiem;
      }else{
        this.time.emit(this.hour + ' : ' + this.minute)
        return this.hour + ' : ' + this.minute ;
      }
      
    
    }
  }
  meridiemChange(event: any) {
    this.meridiem = event.target.value;
    this.valueFormating();
  }
  minChange(event: any) {
    this.minute = event.target.value;
    this.valueFormating();
  }
  HourChange(event: any) {
    this.hour = event.target.value;
    this.valueFormating();
  }
  reset(){
    if(this.field.hourFormat!=24){
      this.minute = new Date().getMinutes() + '';
      this.hour = (new Date().getHours()>12?new Date().getHours()%12:new Date().getHours()) + '';
      this.valueFormating();
    }
    else{
      this.hour = new Date().getHours() + '';
      this.minute = new Date().getMinutes() + '';
    }
   
  }
}
